import type { Ref } from 'vue';
import { refThrottled } from '@vueuse/core';
import { computed } from 'vue';

const SEARCH_THROTTLE_MS = 500;

/**
 * Provides trimmed live and throttled search terms for server-backed option lists.
 */
export function useThrottledSearchTerm(searchTerm: Ref<string>) {
	const throttledSearchTerm = refThrottled(searchTerm, SEARCH_THROTTLE_MS);
	const normalizedSearchTerm = computed(() => throttledSearchTerm.value.trim());
	const currentSearchTerm = computed(() => searchTerm.value.trim());
	const hasActiveSearch = computed(() => Boolean(normalizedSearchTerm.value && currentSearchTerm.value));

	return { normalizedSearchTerm, currentSearchTerm, hasActiveSearch };
}
